import styles from "./progressBar.module.css";

const ProgressBar = ({
    percent = 0,
    height = 5,
    color = "linear-gradient(to right, #cc97fdff, #1fc890ff)",
    trackColor = "#e2ebde",
}) => {
    return (
        <div
            className={styles.progressBar}
            style={{ height: `${height}px`, background: trackColor }}
        >
            <div
                className={styles.progressFill}
                style={{
                    width: `${percent}%`,
                    background: color, // solid or gradient works
                }}
            ></div>
        </div>
    );
};

export default ProgressBar;
